import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useOutletContext, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import toastr from "../../../utils/toast";

function AddModule({ onClose }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  
  const {
      register,
      handleSubmit,
      watch,
      setValue,
      unregister,
      formState: { errors },
    } = useForm();
  const [mainMenu, setmainMenu] = useState([]);
  const [selectType, setselectType] = useState(null);
  
  useEffect(() => {
    async function fetchAllDropdownData() {
      setGlobalLoading(false); //  Show loader before API call
      try {
        const res = await axios.get(`${API_BASE_URL}/settings/get_main_menu_list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      //  const data = res.data;
        setmainMenu(res.data.modules || []);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchAllDropdownData();
  }, []);

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      const response = await axios.post(
        `${API_BASE_URL}/settings/add_module`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    //  console.log(response);
      toastr.success("Module update successfully!");
      onClose();
      setTimeout(() => {
        navigate("/settings/modules");
      }, 1000);

      // setShowModal(false);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  }; 
const typeSelectChange = (e) => {
    setselectType(e.target.value);
  };
   return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "550px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Add Module</h4>
              <button
                onClick={() => onClose()}
                type="button" className="btn-close custom-btn-close"
                data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="mb-2">
                    <label className="form-label">Module Name *</label>
                    <input type="text" {...register("name", { required: "required" })} className={`form-control ${ errors.name && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Link *</label>
                    <input type="text" {...register("link", { required: "required" })} className={`form-control ${ errors.link && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Type *</label>
                      <select {...register("type")} onChange={typeSelectChange} className="form-select">
                        <option value="Main">Main</option>
                        <option value="Child">Child</option>
                      </select>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Icon </label>
                    <input type="text" {...register("icon")} className={`form-control ${ errors.icon && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Sort </label>
                    <input type="text" {...register("sort")} className={`form-control ${ errors.sort && "is-invalid"}`} />
                  </div>
                  {selectType === "Child" ? (
                  <div className="mb-2">
                    <label className="form-label">Parent *</label>
                    <select {...register("parent", {required: "Please select Main Menu",})} className={`form-select ${ errors.parent && "is-invalid" }`}>
                      <option value="">Select</option>
                      {mainMenu.map((m) => (
                        <option key={m.id} value={m.id}>{m.name}</option>
                      ))}
                    </select>
                  </div>
                  ) : ("")}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
   );  

}    
export default AddModule;